import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import App from './app';
import i18n from './i18n';
import { BrowserRouter as Router } from 'react-router-dom';
import { loadGAEditorSDK } from '@wix/platform-editor-sdk/lib/loader';

const baseURL = window.__BASEURL__;
const locale =
  window.initialState.lang !== 'en'
    ? window.initialState.lang
    : window.Wix.Utils.getLocale();
const pathName = location.pathname;

loadGAEditorSDK().then((editorSDK) => {
  ReactDOM.render(
    <Suspense fallback={' '}>
      <I18nextProvider i18n={i18n(locale, pathName)}>
        <Router>
          <App editorSDK={editorSDK} />
        </Router>
      </I18nextProvider>
    </Suspense>,
    document.getElementById('root'),
  );
});
